export function clearNotification(notification) {
    return {
      type: 'CLEAR_NOTIFICATION',
      notification
    }
  }
  